import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitDown1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-split-down, rules, direction, split"><path d="M3.75 14.75V20.25H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.75 20.25H20.25V14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 12V3.75M12 12L4.5 19.5M12 12L19.5 19.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowSplitDown1;
